export default "__VITE_ASSET__3ZBa6vB7__"